module.exports = __webpack_public_path__ + "static/img/tower-crane.30835a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tower-crane.png
// module id = 1eb3
// module chunks = 0